import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from '../tabs.component.module.styl';

import type {ReactNode} from 'react';


const classNames = withCssModule(styles);

interface TabIconProps {
    children: ReactNode,
    position?: 'start' | 'end',
}

export const TabIcon = ({position = 'start', children}: TabIconProps) => {

    const tabIconClasses = classNames('tabs__icon', {
        tabs__icon_right: position === 'end',
    });

    return (
        <div className={tabIconClasses}>{children}</div>
    );
};

TabIcon.displayName = 'TabIcon';
